import { CSSProperties } from 'react'

import { STYLE_SETTING_CLASS_NAME_PREFIX } from '@constants'
import { ConfiguredColumn } from '@types'

import { convertStyleSettingToCss } from './convertStyleSettingToCss'

export const getStyleSettingsFromColumnDisplayRule = (
  columns: ConfiguredColumn[],
  classNamePrefix: string = STYLE_SETTING_CLASS_NAME_PREFIX
) => {
  const styleSettingsStyles: Record<string, CSSProperties> = {}

  columns.map(column => {
    column.displayRule?.displayRuleValues?.forEach(displayRuleValue => {
      const styleSettingCssProperties = convertStyleSettingToCss(displayRuleValue.styleSetting)

      if (styleSettingCssProperties) {
        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${displayRuleValue.styleSetting.code}`
        ] = styleSettingCssProperties

        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${displayRuleValue.styleSetting.code}.MuiDataGrid-cell--pinnedRight`
        ] = styleSettingCssProperties

        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${displayRuleValue.styleSetting.code}.MuiDataGrid-cell--pinnedLeft`
        ] = styleSettingCssProperties
      }
    })

    column.displayRule?.jsSetting?.styleSettings?.map(styleSetting => {
      const styleSettingCssProperties = convertStyleSettingToCss(styleSetting)

      if (styleSettingCssProperties) {
        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${styleSetting.code}`
        ] = styleSettingCssProperties

        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${styleSetting.code}.MuiDataGrid-cell--pinnedRight`
        ] = styleSettingCssProperties

        styleSettingsStyles[
          `.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${classNamePrefix}${styleSetting.code}.MuiDataGrid-cell--pinnedLeft`
        ] = styleSettingCssProperties
      }
    })
  })

  return styleSettingsStyles
}
